<script setup lang="ts">
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
</script>

<template>
  <ButtonComponent class="bg-grey-light text-white">
    <slot/>
  </ButtonComponent>
</template>

<style scoped>
  .active {
    @apply bg-primary;
  }

  *[disabled] {
    @apply bg-grey-lighter;
  }

  *:not([disabled]) {
    @apply hover:bg-primary;
  }
</style>
